var map = {
	"./PitchArtPrevPitchValueToggle": 66890,
	"./PitchArtPrevPitchValueToggle.css": 50389,
	"./PitchArtPrevPitchValueToggle.scss": 1760,
	"./PitchArtPrevPitchValueToggle.tsx": 66890,
	"./StaticWordSyallableData": 86150,
	"./StaticWordSyallableData.tsx": 86150,
	"./StudentRecordings": 30468,
	"./StudentRecordings.css": 4745,
	"./StudentRecordings.scss": 56548,
	"./StudentRecordings.test": 76624,
	"./StudentRecordings.test.tsx": 76624,
	"./StudentRecordings.tsx": 30468,
	"./StudentsInfo": 97121,
	"./StudentsInfo.css": 54518,
	"./StudentsInfo.scss": 34741,
	"./StudentsInfo.tsx": 97121,
	"./WordSyllableCategories": 54841,
	"./WordSyllableCategories.css": 42182,
	"./WordSyllableCategories.scss": 71869,
	"./WordSyllableCategories.tsx": 54841,
	"./WordSyllableReview": 40585,
	"./WordSyllableReview.css": 11162,
	"./WordSyllableReview.scss": 4433,
	"./WordSyllableReview.test": 44908,
	"./WordSyllableReview.test.tsx": 44908,
	"./WordSyllableReview.tsx": 40585,
	"./images/EOP-AF-saahkomaapiwa_mono.wav": 51866,
	"./images/Pitch Art - 21-01.jpg": 72487,
	"./images/Pitch Art - 22-01.jpg": 75818,
	"./images/Pitch Art - 31-01.jpg": 77254,
	"./images/Pitch Art - 32-01.jpg": 47971,
	"./images/Pitch Art - 33-01.jpg": 34508,
	"./images/Pitch Art - 41-01.jpg": 3869,
	"./images/Pitch Art - 42-01.jpg": 47436,
	"./images/Pitch Art - 43-01.jpg": 40995,
	"./services/WordSyllables": 17525,
	"./services/WordSyllables.ts": 17525,
	"./types": 20798,
	"./types.ts": 20798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63926;